import { ButtonProps } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export type Action = Omit<
  Pick<
    ButtonProps,
    | "id"
    | "key"
    | "type"
    | "form"
    | "icon"
    | "isIconOnly"
    | "label"
    | "disabled"
    | "isDanger"
    | "onClick"
    | "data-testid"
    | "className"
    | "href"
    | "variant"
  >,
  "onClick"
> &
  Required<Pick<ButtonProps, "label">> & {
    onClick?: (event?: React.MouseEvent<HTMLElement>) => void
  }

export const ActionGroupTypename = "ActionGroup" as const

export interface ActionGroup<ActionType extends Action = Action> {
  id: string
  key: string
  icon?: IconName
  label: string
  actions: (ActionType | ActionGroup<ActionType>)[]
  __typename: typeof ActionGroupTypename
}

export function isActionGroup(
  action: Action | ActionGroup
): action is ActionGroup {
  return (
    Object.hasOwn(action, "__typename") &&
    (action as { __typename: unknown }).__typename === ActionGroupTypename
  )
}
